{
    "copy_successful": "Copié dans le presse-papiers.",
    "copy_failed": "Impossible de copier dans le presse-papiers."
}
